import { render, staticRenderFns } from "./UnitMatrixView.vue?vue&type=template&id=279c01c2&"
import script from "./UnitMatrixView.vue?vue&type=script&lang=ts&"
export * from "./UnitMatrixView.vue?vue&type=script&lang=ts&"
import style0 from "./UnitMatrixView.vue?vue&type=style&index=0&id=279c01c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports